import React from 'react';
import { logout } from '../../lib/auth';

class ClearPage extends React.Component {
  public componentDidMount() {
    logout();
  }

  public render() {
    return <div>Clearing...</div>;
  }
}

export default ClearPage;
